<template>
    <div class="bubble" :class="color !== '' ? 'bubble--' + color : ''" v-if="count">
        <span>{{ count }}</span>
    </div>
</template>

<script>
export default
{
    name: 'Bubble',

    props: ['count', 'color'],
}
</script>



// WEBPACK FOOTER //
// Bubble.vue?42985d0c